import React, { useEffect, useState } from 'react'
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { Button, Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Helpers
import { objCampo, validarCampos } from '../../../../helpers/ValidadorDeCampos';

//Components
import TextField from '../../../../components/TextField/TextField';
import TabelaQuestao from './TabelaQuestao';

//Helpers
import mascaras from '../../../../helpers/mascaras';
import uuid from 'helpers/guid';

//Contatnts
import { actionsTable } from '../../../../constants/MaterialTable';

//helpers
import { showQuestion, showMessage } from '../../../../helpers/message';

//Estado inicial da questão
function initialStateQuestao(bloco_Hash = null) {
  return {
    sequencia: "",
    descricao: "",
    tipoValor: null,
    obrigatorio: false,
    possuiDependencia: false,
    tbFormularioPGRSBlocoQuestaoOpcoes: [],
    tbFormularioPGRSBlocoQuestaoDependentes: [],
    questaoVinculada: null,
    valorQuestaoVinculada: "",
    opcoesQueGeramInconformidade: [],
    hash: "",
    deletado: false,
    bloco_Hash
  }
}

//Estado inicial da questão dependente
function initialStateQuestaoDependente() {
  return {
    questaoPai_UUID: "",
    questaoPai_Valor: "",
  }
}

export default function Questoes({ formulario, setFormulario }) {
  //Estado de controle dos errors
  const [errors, setErrors] = useState({});

  //Estado de controle dos dados da questao
  const [questao, setQuestao] = useState(initialStateQuestao());

  //Estado de controle da questão dependente
  const [questaoDependente, setQuestaoDependente] = useState(initialStateQuestaoDependente());

  const [optionsBlocos, setOptionsBlocos] = useState([]);

  //Estado de controle das opções das questões vinculadas
  const [optionsQuestoesVinculadas, setOptionsQuestoesVinculadas] = useState([]);

  //Opções dos selects de tipo de valor
  const optionsTipoValor = [
    { label: "Data", value: "Data" },
    { label: "Lista", value: "Lista" },
    { label: "Número", value: "Número" },
    { label: "Texto", value: "Texto" }
  ];

  //Campos obrigatorios no cadastro de um novo cabeçalho
  const [camposObrigatorios, setCamposObrigatorios] = useState([
    objCampo({ name: "sequencia", required: true }),
    objCampo({ name: "descricao", required: true }),
    objCampo({ name: "tipoValor", required: true }),
  ]);

  //onChange para os campos de texto do formulario de cabeçalho
  const onChangeTexto = (e) => {
    const { name, value } = e.target;
    setQuestao({
      ...questao,
      [name]: value
    });
  }

  //onChange para o campo de select de tipo de valor
  const onChangeTipoValor = (e, select) => {
    if (e.value == "Lista") {
      setCamposObrigatorios([
        ...camposObrigatorios,
        objCampo({ name: "tbFormularioPGRSBlocoQuestaoOpcoes", required: true })
      ])
    } else {
      setCamposObrigatorios([...camposObrigatorios.filter(v => v.name != "tbFormularioPGRSBlocoQuestaoOpcoes")]);
    }
    setQuestao({
      ...questao,
      tbFormularioPGRSBlocoQuestaoOpcoes: e == null || e.value != "Lista" ? [] : questao.tbFormularioPGRSBlocoQuestaoOpcoes,
      [select.name]: e != null ? e.value : null
    })
  }

  //onChange para o campo de select de tipo de valor
  const onChangeBlocoSearchable = (e, select) => {
    if (e && formulario?.tbFormularioPGRSBlocos?.filter(x => x.hash == e.value)[0]) {
      const _questoesVinculadas = formulario.tbFormularioPGRSBlocos.filter(x => x.hash == e.value)[0]?.tbFormularioPGRSBlocoQuestoes ?? []
      setOptionsQuestoesVinculadas(_questoesVinculadas.map((value, index) => { return { label: value.descricao, value: value.hash } }));
    }
    setQuestao({ ...questao, [select.name]: e != null ? e.value : null })
  }

  //OnChange para o checkbox
  const onChangeCheckbox = (e) => {
    const { name, checked } = e.target;
    setQuestao({
      ...questao,
      [name]: checked
    })
  }


  const onChangeOpcoes = (inputValue) => {
    const opcoesQueGeramInconformidade = questao?.opcoesQueGeramInconformidade?.filter(op => (typeof inputValue == "object" && inputValue.filter(v => v.value == op.value).length > 0) || typeof inputValue != "object");
    setQuestao({
      ...questao,
      opcoesQueGeramInconformidade,
      tbFormularioPGRSBlocoQuestaoOpcoes: typeof inputValue === "object" ? [...inputValue] : [...questao.tbFormularioPGRSBlocoQuestaoOpcoes, { value: inputValue, label: inputValue }]
    });
  }

  //Ações da tabela de cabeçalhos
  const actions = [
    actionsTable.editar((rowData) => {
      rowData.obrigatorio = rowData.obrigatorio == "Sim" || rowData.obrigatorio == true ? true : false;
      rowData.possuiDependencia = rowData.possuiDependencia == "Sim" || rowData.possuiDependencia == true ? true : false;

      setQuestao({ ...rowData });
    }),
    actionsTable.remover((rowData) => {
      showQuestion("Tem certeza disso?", "Você tem certeza de que deseja remover esta questão? Esta é uma ação irreversível", "warning", (confirmation) => removerQuestao(rowData, confirmation));
    })
  ]

  //Função que remove uma questao
  const removerQuestao = (_questao, confirmacao) => {
    if (!confirmacao) return;

    setFormulario(prevFormulario => {
      const atualizadoBloco = prevFormulario.tbFormularioPGRSBlocos.map(bloco_Hash => {
        if (bloco_Hash.hash === questao.bloco_Hash)
          return { ...bloco_Hash, tbFormularioPGRSBlocoQuestoes: bloco_Hash.tbFormularioPGRSBlocoQuestoes.filter(q => q.hash !== _questao.hash) };
        return bloco_Hash;
      });
      return { ...prevFormulario, tbFormularioPGRSBlocos: atualizadoBloco };
    });

    setQuestao(initialStateQuestao(questao.bloco_Hash));
  };

  //Função que adiciona uma questão a lista
  const adicionarQuestao = () => {
    //validando os campos
    let _errors = validarCampos(questao, camposObrigatorios);
    setErrors({ ..._errors[0] });
    if (_errors[1].length > 0) {
      return;
    }

    let _formulario = { ...formulario }

    //pegar o bloco_Hash selecionando
    const _bloco = formulario.tbFormularioPGRSBlocos.filter(x => x.hash == questao.bloco_Hash)[0];
    const _questao = { ...questao };

    if (!!_bloco) {
      if (_questao.tableData) {
        _bloco.tbFormularioPGRSBlocoQuestoes = _bloco.tbFormularioPGRSBlocoQuestoes.map((value, index) => {
          if (_questao.tableData.id === index) {
            return { ..._questao };
          }
          return value;
        });

        _formulario.tbFormularioPGRSBlocos = _formulario.tbFormularioPGRSBlocos.map(bloco_Hash => {
          if (bloco_Hash.hash == _questao.bloco_Hash)
            return _bloco;
          return bloco_Hash;
        })

        setQuestaoDependente(initialStateQuestaoDependente());
        _bloco.tbFormularioPGRSBlocoQuestoes.map((value, index) => { return { label: value.descricao, value: value.hash } });
      }
      else {
        _questao.hash = uuid();

        _bloco.tbFormularioPGRSBlocoQuestoes = [..._bloco.tbFormularioPGRSBlocoQuestoes, { ..._questao }];

        _formulario.tbFormularioPGRSBlocos = _formulario.tbFormularioPGRSBlocos.map(bloco_Hash => {
          if (bloco_Hash.hash == questao.bloco_Hash)
            return _bloco;

          return bloco_Hash;
        })
        setQuestaoDependente(initialStateQuestaoDependente());

        _bloco.tbFormularioPGRSBlocoQuestoes.map((value, index) => { return { label: value.descricao, value: value.hash } });
      }

    }
    setFormulario(_formulario)
    setQuestao(initialStateQuestao(questao.bloco_Hash));
  }

  useEffect(() => {
    if (formulario.tbFormularioPGRSBlocos.length > 0) {
      let blocos = formulario?.tbFormularioPGRSBlocos?.map(bloco_Hash => {
        return { label: bloco_Hash.identificacao, value: bloco_Hash.hash }
      })
      setOptionsBlocos([...blocos])
    }
  }, [formulario?.tbFormularioPGRSBlocos]);

  return (
    <div>
      <div className={`formContainer mb-4`}>
        <Row>
          <Col md="12" lg={questao.bloco_Hash ? "4" : "12"}>
            <TextField
              label={"* Selecione o bloco"}
              options={optionsBlocos}
              type="select"
              searchable
              onChange={onChangeBlocoSearchable}
              name={"bloco_Hash"}
              value={optionsBlocos.filter(x => x.value == questao.bloco_Hash)[0]}
            />
          </Col>

          {questao.bloco_Hash != null &&
            <>
              <Col md="12" lg="2">
                <TextField
                  invalid={!!errors.sequencia}
                  label={"* Sequência"}
                  onChange={onChangeTexto}
                  name={"sequencia"}
                  value={questao.sequencia}
                  mask={mascaras.numeroMask}
                />
              </Col>
              <Col md="12" lg="6">
                <TextField
                  invalid={!!errors.descricao}
                  label={"* Descrição"}
                  onChange={onChangeTexto}
                  name={"descricao"}
                  value={questao.descricao}
                />
              </Col>
              <Col md="12" lg="4">
                <TextField
                  invalid={!!errors.tipoValor}
                  label={"* Tipo de valor"}
                  options={optionsTipoValor}
                  type="select"
                  searchable
                  onChange={onChangeTipoValor}
                  name={"tipoValor"}
                  value={questao.tipoValor != null ? optionsTipoValor.filter(v => v.value === questao.tipoValor)[0] : null}
                />
              </Col>
              <Col md="12" lg="2" className='mt-2'>
                <TextField
                  label={"Campo obrigatório"}
                  type="checkbox"
                  onChange={onChangeCheckbox}
                  value={questao.obrigatorio}
                  name={"obrigatorio"}
                />
              </Col>
              {questao.tipoValor === "Lista" &&
                <>
                  <Col md="12" lg="12" className='mt-2'>
                    <TextField
                      invalid={!!errors.tbFormularioPGRSBlocoQuestaoOpcoes}
                      label={"* Opções de resposta"}
                      type="select"
                      creatable
                      name={"tbFormularioPGRSBlocoQuestaoOpcoes"}
                      onChange={onChangeOpcoes}
                      value={questao.tbFormularioPGRSBlocoQuestaoOpcoes}
                      maxLength={300}
                    />
                  </Col>
                </>
              }
              <div className='w-100 d-flex align-items-center justify-content-center'>
                <Button color='success' onClick={adicionarQuestao}><FontAwesomeIcon icon={faSave} /> <span className="fw-bold">Salvar</span></Button>
              </div>
            </>
          }

        </Row>
      </div>
      <TabelaQuestao
        actions={actions}
        items={formulario?.tbFormularioPGRSBlocos?.filter(x => x.hash == questao.bloco_Hash)[0]?.tbFormularioPGRSBlocoQuestoes ?? []}
      />
    </div>
  )
}
